var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84.528,
    height: 57.192,
    viewBox: "0 0 84.528 57.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17329",
    "data-name": "Group 17329",
    transform: "translate(-917.816 -989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_481",
    "data-name": "Path 481",
    transform: "translate(950 989)",
    fill: "none",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,0A10,10,0,0,1,20,10V26A10,10,0,0,1,0,26V10A10,10,0,0,1,10,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 1 C 5.037380218505859 1 1 5.037380218505859 1 10 L 1 26 C 1 30.96261978149414 5.037380218505859 35 10 35 C 14.96261978149414 35 19 30.96261978149414 19 26 L 19 10 C 19 5.037380218505859 14.96261978149414 1 10 1 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 L 20 26 C 20 31.52285003662109 15.52285003662109 36 10 36 C 4.477149963378906 36 0 31.52285003662109 0 26 L 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_693",
    "data-name": "Rectangle 693",
    transform: "translate(954 1002)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 19,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 18,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M4.7.192a3.414,3.414,0,0,0,3.68-3.3c0-1.568-1.12-2.528-2.992-3.024l-1.44-.384c-1.472-.384-1.6-1.152-1.6-1.536A1.983,1.983,0,0,1,4.48-9.872a1.922,1.922,0,0,1,2.1,1.856h1.44a3.224,3.224,0,0,0-3.488-3.2A3.387,3.387,0,0,0,.9-8.032c0,.9.368,2.272,2.7,2.832l1.424.352c.928.24,1.9.72,1.9,1.792A2.011,2.011,0,0,1,4.7-1.152,2.279,2.279,0,0,1,2.256-3.12H.816A3.613,3.613,0,0,0,4.7.192Zm9.1,0A3.776,3.776,0,0,0,16.656-.992l-.88-.912a2.638,2.638,0,0,1-1.92.784A2.583,2.583,0,0,1,11.2-3.744a2.57,2.57,0,0,1,2.656-2.608,2.638,2.638,0,0,1,1.92.784l.88-.912a3.835,3.835,0,0,0-2.848-1.184,3.887,3.887,0,0,0-4.016,3.92A3.9,3.9,0,0,0,13.808.192ZM21.92-7.664c-.992,0-1.712.576-2.1,1.888v-1.7H18.416V0h1.408V-2.736c0-1.968.592-3.584,2.08-3.584a2.586,2.586,0,0,1,1.088.256l.224-1.312A2.821,2.821,0,0,0,21.92-7.664ZM27.744.192a3.831,3.831,0,0,0,3.92-3.936,3.817,3.817,0,0,0-3.92-3.92,3.8,3.8,0,0,0-3.9,3.92A3.818,3.818,0,0,0,27.744.192Zm0-1.312a2.51,2.51,0,0,1-2.5-2.624,2.506,2.506,0,0,1,2.5-2.608,2.522,2.522,0,0,1,2.528,2.608A2.526,2.526,0,0,1,27.744-1.12ZM34.992,0V-11.536H33.6V0ZM38.8,0V-11.536H37.408V0Zm6.784-11.024V0h4.272c3.136,0,4.976-2.368,4.976-5.488,0-3.136-1.84-5.536-4.976-5.536Zm1.456,9.68V-9.68h2.816c2.32,0,3.52,1.84,3.52,4.192s-1.2,4.144-3.52,4.144ZM60.272.192a3.831,3.831,0,0,0,3.92-3.936,3.817,3.817,0,0,0-3.92-3.92,3.8,3.8,0,0,0-3.9,3.92A3.818,3.818,0,0,0,60.272.192Zm0-1.312a2.51,2.51,0,0,1-2.5-2.624,2.506,2.506,0,0,1,2.5-2.608A2.522,2.522,0,0,1,62.8-3.744,2.526,2.526,0,0,1,60.272-1.12ZM73.6-2.16,71.68-7.472H70.32l-1.9,5.312-1.9-5.312h-1.5L67.856,0h1.152l1.984-5.552L73.056,0h1.168l2.784-7.472H75.5Zm8.736-5.5a2.88,2.88,0,0,0-2.48,1.328V-7.472H78.464V0h1.392V-4.048a2.158,2.158,0,0,1,2.288-2.24A1.846,1.846,0,0,1,83.952-4.24V0h1.392V-4.32C85.36-6.416,84.192-7.664,82.336-7.664Z",
    transform: "translate(917 1046)",
    fill: "#707070",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollSvg);
export default __webpack_public_path__ + "static/media/scroll-svg.6318bcd8ac69ace0730e06d464075521.svg";
export { ForwardRef as ReactComponent };